import { DataSensitivityLevelId } from '@types';

export const DATA_SENSITIVITY_COLORS: Record<DataSensitivityLevelId, string> = {
	[ DataSensitivityLevelId.None ]: '',
	[ DataSensitivityLevelId.Public ]: 'green',
	[ DataSensitivityLevelId.Internal ]: 'gold',
	[ DataSensitivityLevelId.Confidential ]: 'volcano',
	[ DataSensitivityLevelId.Restricted ]: 'red',
	[ DataSensitivityLevelId.MissionCritical ]: 'magenta'
};

export const DATA_SENSITIVITY_LABELS: Record<DataSensitivityLevelId, string> = {
	[ DataSensitivityLevelId.None ]: 'No Data Sensitivity Level',
	[ DataSensitivityLevelId.Public ]: 'Public',
	[ DataSensitivityLevelId.Internal ]: 'Internal',
	[ DataSensitivityLevelId.Confidential ]: 'Confidential',
	[ DataSensitivityLevelId.Restricted ]: 'Restricted',
	[ DataSensitivityLevelId.MissionCritical ]: 'Mission Critical'
};
